import React from 'react';

import { css } from 'glamor';

import { RED } from 'depop/styles/colors';

const rotateKeyframes = css.keyframes('rotate', {
  '100%': { transform: 'rotate(360deg)'}
});

const dashKeyframes = css.keyframes('dash', {
  '0%': {
    strokeDasharray: '1 150',
    strokeDashoffset: '0',
  },
  '30%': {
    strokeDasharray: '90 150',
    strokeDashoffset: '-35',
  },
  '100%': {
    strokeDasharray: '90 150',
    strokeDashoffset: '-124',
  }
});

const spinnerStyle = css({
  animation: `${rotateKeyframes} 1s linear infinite`,
  zIndex: 2,
  position: 'absolute',
  top: '50%',
  left: '50%',
  margin: '-25px 0 0 -25px',
  width: '50px',
  height: '50px',
  '>.path': {
    stroke: RED,
    animation: `${dashKeyframes} 1.5s ease-in-out infinite`
  }
});

export default (props = {}) => (
  <svg { ...spinnerStyle } className="spinner" viewBox="0 0 50 50">
    <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
  </svg>
);



// WEBPACK FOOTER //
// ../src/client/components/icons/Spinner.js